export default function (self, activeElement) {
  const parent = activeElement.closest('.keynav')
  if (parent && parent.className) {
    if (parent.className.includes('el-select')) {
      let id
      if (parent.getElementsByTagName('div')[0].id) {
        id = parent.getElementsByTagName('div')[0].id
      } else {
        id = parent.getElementsByTagName('input')[0].id
      }
      return self.$refs[id] ? self.$refs[id][0] : null
    }
    try {
      if (self.$refs[parent.id]) {
        return self.$refs[parent.id][0]
      } else {
        return self.$refs[`autocomplete__${parent.id}`] ? self.$refs[`autocomplete__${parent.id}`][0] : null
      }
    } catch (e) {
      throw new TypeError(e)
    }
  }
  return null // Return null if parent is not found or doesn't match conditions
}
